// extracted by mini-css-extract-plugin
export default {"termDefinition":"termDefinition--2XkZX"};